import { classNames } from '../helper/classNames';

interface Props {
  readonly tag?: string;
  readonly children: any;
}

export function WidgetTitle(props: Props | any) {
  const Tag = props.tag || 'h2';

  const customProps = {
    ...props,
    className: classNames('text-lg font-bold', props.className),
  };

  delete customProps.tag;

  if (!props.children) return null;

  return <Tag {...(customProps as any)} />;
}
